<template>
    <div id="dekonstrukt-search-history">
        <AppHero :heading="'Check Search History'"/>

        <section class="history">
            <div class="container container--mw-xxl">
                <HistoryBlock
                    @update:view="viewUpdate4"
                    v-for='(h,index) in history'
                    :key="index"
                    :search_token="h.search_token"
                    :job_type="h.job_type.split(',')"
                    :trademark_cat="JSON.parse(h.trademark_cat)"
                    :date="h.request_date"
                    :info-heading-one="h.keyword"
                    :dekonstruktorHistoryButton="true"
                    :konstruktorHistoryButton="false"
                    :button-text="'View Report'"
                />
            </div>
        </section>

        <!--        <div class="pagination-section" v-if="totalRecord > 2">-->
        <!--            <button v-if="previousUrl != null" @click="paginationPrev" class="btn blue">Prev</button>-->
        <!--            <hr v-if="previousUrl != null">-->
        <!--            <button v-if="nextUrl != null" @click="paginationNext" class="btn blue">Next</button>-->
        <!--        </div>-->

        <CallToAction
            :copy="'Which Khonsu Plan is best for me?'"
            :button-text="'Click here to view our different pricing models'"
            :button-link="'/'"
        />
    </div>
</template>

<script>
    import AppHero from "@/components/layout/AppHero";
    import HistoryBlock from "@/components/blocks/HistoryBlock";
    import CallToAction from "@/components/layout/CallToAction";

    export default {
        name: 'HistoryDekonstruktor',
        metaInfo: {
            title: 'Khonsu - Check Search History'
        },
        components: {
            AppHero,
            HistoryBlock,
            CallToAction
        },
        computed: {
            /*This  get the current step */
            history: function () {
                return this.$store.state.SearchHistory.history;
            },
            // totalRecord: function () {
            //
            //     return this.$store.state.SearchHistory.totalRecord;
            // },
            // previousUrl: function () {
            //     return this.$store.state.SearchHistory.previousUrl;
            // },
            // nextUrl: function () {
            //     return this.$store.state.SearchHistory.nextUrl;
            // }
        },

        data() {
            return {}
        },
        methods: {
            // paginationPrev: function () {
            //     this.$store.dispatch('BrandDeKonstrucktor/getHistory', {
            //         'user_id': parseInt(sessionStorage.getItem('user_id')),
            //         'search_type': 'dekonstruktor',
            //         'url': this.$store.state.SearchHistory.previousUrl
            //     });
            // },
            // paginationNext: function () {
            //     this.$store.dispatch('BrandDeKonstrucktor/getHistory', {
            //         'user_id': parseInt(sessionStorage.getItem('user_id')),
            //         'search_type': 'dekonstruktor',
            //         'url': this.$store.state.SearchHistory.nextUrl
            //     });
            // },
            viewUpdate4: function () {
                this.$emit('update:view', false);
            }
        },
        mounted() {
            this.$store.dispatch('BrandDeKonstrucktor/getHistory', {
                'user_id': parseInt(sessionStorage.getItem('user_id')),
                'search_type': 'dekonstruktor'
            });
        }

    }
</script>


<style>
    .pagination-section {
        margin-top: 2%;
        display: flex;
        justify-content: center;

    }

    .dekonstrukt-search-history{
    background-color:  linear-gradient(150deg,#4e5797,#031755)
    }
</style>